import { Box, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import ICoBrowseDto from "../../../../interface/ICoBrowseDto";
import { CoBrowseContext } from "../../../../store/coBrowse.context";
import React from "react";

const CoBrowseOffer = (): React.JSX.Element => {
  const {
    coBrowseDto,
    startCoBrowsing,
    declineCoBrowseSession,
  }: {
    coBrowseDto: ICoBrowseDto;
    startCoBrowsing: () => void;
    declineCoBrowseSession: () => void;
  } = React.useContext(CoBrowseContext);

  return (
    <Grid
      size={8}
      sx={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "20px",
        }}
      >
        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={startCoBrowsing}
          disabled={coBrowseDto.loading}
        >
          Annehmen
        </Button>

        <Button
          size="small"
          variant="outlined"
          color="primary"
          onClick={declineCoBrowseSession}
          disabled={coBrowseDto.loading}
        >
          Ablehnen
        </Button>
      </Box>
    </Grid>
  );
};

export default CoBrowseOffer;
